(function () {
	"use strict";

	angular.module("angular.emlpayments")
		.factory("customerService", customerServiceFactory);

	customerServiceFactory.$inject = ["api", "appConfig",];

	function customerServiceFactory(api, appConfig) {
		var searchCustomerCriteria = null, activateCardCustomer;

		return {
			searchCustomers,
			searchCustomerCards,
			updateCustomer,
			getSearchCustomerCriteria,
			setActivateCardCustomer,
			getActivateCardCustomer,
			mapCustomerForActivation,
			getOrganizationIncentiveTypes,
			getOrganizationCountryOfOperation,
			getCardFundingSources,
			getCompanyTypes,
			getIndustryTypes,
			getBusinessSizes,
			getCountriesOfOperation,
			getIncentiveTypes,
			getKybStatuses,
			reset
		};

		function setActivateCardCustomer(customer) {
			activateCardCustomer = customer;
		}

		function getActivateCardCustomer() {
			return activateCardCustomer;
		}

		function mapCustomerForActivation() {
			if (!activateCardCustomer) {
				return undefined;
			}

			return {
				firstName: activateCardCustomer.firstName 
					? activateCardCustomer.firstName 
					: activateCardCustomer.documentedPerson 
					? activateCardCustomer.documentedPerson.firstName 
					: null,
				middleName: activateCardCustomer.middleName,
				lastName: activateCardCustomer.lastName
					? activateCardCustomer.lastName
					: activateCardCustomer.documentedPerson
					? activateCardCustomer.documentedPerson.lastName
					: null,
				phone: activateCardCustomer.phoneNumber,
				phoneExt: activateCardCustomer.phoneNumberExtension,
				fax: activateCardCustomer.faxNumber,
				faxExt: activateCardCustomer.faxNumberExtension,
				email: activateCardCustomer.emailAddress,
				country: angular.copy(activateCardCustomer.selectedCountry),
				address1: activateCardCustomer.address1,
				address2: activateCardCustomer.address2,
				city: activateCardCustomer.city,
				selectedRegion: activateCardCustomer.selectedRegion,
				postalCode: activateCardCustomer.postalCode,
				companyName: activateCardCustomer.name,
				isOrganization: activateCardCustomer.isOrganization,
				marketingOptIn: activateCardCustomer.marketingOptIn,
				identifier: activateCardCustomer.identifier,
				companyRegistrationNumber: activateCardCustomer.companyRegistrationNumber,
				vat: activateCardCustomer.vat,
				birthDate: activateCardCustomer.birthDate
					? activateCardCustomer.birthDate
					: activateCardCustomer.documentedPerson
					? activateCardCustomer.documentedPerson.birthDate
					: null,
				kycDocumentType: activateCardCustomer.kycDocumentType
					? activateCardCustomer.kycDocumentType
					: activateCardCustomer.documentedPerson
					? activateCardCustomer.documentedPerson.identityDocumentType
					: null,
				kycDocumentId: activateCardCustomer.kycDocumentId
					? activateCardCustomer.kycDocumentId
					: activateCardCustomer.documentedPerson
					? activateCardCustomer.documentedPerson.identityDocumentId
					: null,
				kycExpiryDate: activateCardCustomer.kycExpiryDate
					? activateCardCustomer.kycExpiryDate
					: activateCardCustomer.documentedPerson
					? new Date(activateCardCustomer.documentedPerson.identityDocumentExpirationDate)
					: null,
				requireCIP: activateCardCustomer.requireCIP,
				documentedPerson: activateCardCustomer.documentedPerson
			};
		}

		function searchCustomers(searchCustomerModel) {

			searchCustomerCriteria = searchCustomerModel;

			return api.customer.searchCustomers(appConfig.selectedMerchantGroup().uniqueTag,
				searchCustomerModel.isOrganization,
				searchCustomerModel.name,
				searchCustomerModel.firstName,
				searchCustomerModel.lastName,
				searchCustomerModel.phoneNumber,
				searchCustomerModel.identifier,
				searchCustomerModel.email,
				searchCustomerModel.kybAssessmentLevel,
				searchCustomerModel.companyRegistrationNumber,
				searchCustomerModel.assessmentFromDate,
				searchCustomerModel.assessmentToDate,
				searchCustomerModel.kybStatus);
		}

		function searchCustomerCards(isOrganization, customerId, pageNumber, pageSize) {
			return api.customer.searchCustomerCards(isOrganization, customerId, pageNumber, pageSize);
		}

		function updateCustomer(updateModel) {
			if (updateModel.incorporationDate != null) 
				updateModel.incorporationDate = new Date(updateModel.incorporationDate).toLocaleDateString('en-US');
			if (updateModel.birthDate != null)
				updateModel.birthDate = new Date(updateModel.birthDate).toLocaleDateString('en-US');

			return api.customer.updateCustomer(appConfig.selectedMerchantGroup().uniqueTag, updateModel);
		}

		function getSearchCustomerCriteria() {
			return searchCustomerCriteria;
		}

		function getOrganizationIncentiveTypes(customerId) {
			return api.customer.getOrganizationIncentiveTypes(customerId);
		}

		function getOrganizationCountryOfOperation(customerId) {
			return api.customer.getOrganizationCountryOfOperation(customerId);
		}

		function getCardFundingSources() {
			return api.customer.getCardFundingSources();
		}

		function getCompanyTypes() {
			return api.customer.getCompanyTypes();
		}

		function getIndustryTypes() {
			return api.customer.getIndustryTypes();
		}

		function getBusinessSizes() {
			return api.customer.getBusinessSizes();
		}

		function getCountriesOfOperation() {
			return api.customer.getCountriesOfOperation();
		}

		function getIncentiveTypes() {
			return api.customer.getIncentiveTypes();
		}

		function getKybStatuses() {
			return api.customer.getKybStatuses();
		}

		function reset() {
			searchCustomerCriteria = null;
			activateCardCustomer = undefined;
		}
	}
}());